import { TravelMutationDto, TravelOverviewDto } from '../registrationConfig'

export const mapTravelOverviewDtoToMutation = (dto: TravelOverviewDto): TravelMutationDto => ({
    userId: dto.user?.id,
    distance: dto.distance,
    description: dto.description || undefined,
    date: dto.date,
    rate: dto.rate?.amount,
    currency: dto.rate?.currency,
    billable: dto.billable,
    fileId: dto.file?.id,
})
